export const HOLDING_TYPES = {
  E: {
    name: 'equity',
    title: 'Equity Holdings',
    holdingId: 'equityHoldings',
    collapseId: 'equityHoldingsCollapse',
    tableSelector: 'equity-holdings-table',
    fields: [
      {
        name: 'secName',
        header: 'Security Name',
        type: 'string',
      },
      {
        name: 'shares',
        header: 'Shares',
        type: 'number',
      },
      {
        name: 'value',
        header: 'Value ($)',
        type: 'currency',
      },
      {
        name: 'secPercent',
        header: '% of Net Assets',
        type: 'percent',
      },
    ],
  },
  F: {
    name: 'fixed',
    title: 'Fixed Income Holdings',
    holdingId: 'fixedHoldings',
    collapseId: 'fixedHoldingsCollapse',
    tableSelector: 'fixed-income-table',
    fields: [
      {
        name: 'secName',
        header: 'Fixed Income Security Name',
        type: 'string',
      },
      {
        name: 'rate',
        header: 'Rate (%)',
        type: 'string',
      },
      {
        name: 'maturity',
        header: 'Maturity',
        type: 'date',
      },
      {
        name: 'par',
        header: 'PAR',
        type: 'number',
      },
      {
        name: 'value',
        header: 'Value ($)',
        type: 'currency',
      },
      {
        name: 'secPercent',
        header: '% of Net Assets',
        type: 'percent',
      },
    ],
  },
  G: {
    name: 'generic',
    title: 'Holdings',
    holdingId: 'genericHoldings',
    collapseId: 'genericHoldingsCollapse',
    tableSelector: 'equity-holdings-table',
    fields: [
      {
        name: 'secName',
        header: 'Security Name',
        type: 'string',
      },
      {
        name: 'rate',
        header: 'Rate (%)',
        type: 'string',
      },
      {
        name: 'maturity',
        header: 'Maturity',
        type: 'date',
      },
      {
        name: 'par',
        header: 'PAR',
        type: 'number',
      },
      {
        name: 'value',
        header: 'Value ($)',
        type: 'currency',
      },
      {
        name: 'secPercent',
        header: '% of Net Assets',
        type: 'percent',
      },
    ],
  },
  W: {
    name: 'alt',
    title: 'Holdings',
    holdingId: 'altHoldings',
    collapseId: 'altHoldingsCollapse',
    tableSelector: 'equity-holdings-table',
    fields: [
      {
        name: 'secName',
        header: 'Security Name',
        type: 'string',
      },
      {
        name: 'percentMarketValue',
        header: '% of Notional',
        type: 'percent',
      },
    ],
  },
}

export const ETF_AND_INTERVAL_FIELDS = [
  {
    name: 'description',
    header: 'Description',
    type: 'string',
  },
  {
    name: 'displaySymbol',
    header: 'Ticker',
    type: 'string',
  },
  {
    name: 'assetType',
    header: 'Asset Type',
    type: 'string',
  },
  {
    name: 'quantity',
    header: 'Quantity',
    type: 'number',
  },
  {
    name: 'weightPercentage',
    header: 'Weight (%)',
    type: 'percent',
  },
  {
    name: 'marketValue',
    header: 'Market Value',
    type: 'percent',
  },
  {
    name: 'notionalValue',
    header: 'Notional',
    type: 'percent',
  },
]
